import OPathSettings from './o-path-settings.vue';

export default OPathSettings;